import React, { useState, useEffect } from 'react';
import styles from './ResetPassword.module.scss';
import { CustomTextField } from '../../shared/customTextField';
import { CustomButton } from '../../shared/customButton';
import { CustomTextFieldPass } from '../../shared/textFieldPass';
import { Row, Col, Form, Image } from 'react-bootstrap';
import { resetPassword } from '../../../services/util/auth';
import { CustomAlertBox } from '../../shared/customAlertBox'; 
import { CustomModalIcon } from '../../shared/customModalIcon';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';

const ResetPassword = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [message, setMessage] = useState();
    const [show, setShow] = useState(false);
    let history = useNavigate();

    const backClicked = () => {
        props.Previous(1);
    }

    const backToSignin = () => {
        history("/signin");
    }

    const onSubmit = async (values) => {
        setLoading(true);
        let response = await resetPassword(props.setEmail, values.password, values.code)
        if (response.success === true) {
            setLoading(false)
            history("/signin");
        }
        else {
            setMessage(response.msg)
            setLoading(false)
            setShow(true)
        }
    }

    const schema = yup.object({
        code: yup.number().typeError('Only Numbers are Accepted').required('Verification Code Required'),
        password: yup.string().min(8, 'Minimum length is 8 characters').required('New Password Required')
    });

    useEffect(() => {
        ReactGA.initialize([{
            trackingId: `${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`
        }]);

        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    return (
        <div>
            <Helmet>
                <title>Forgot Password | HireTrace</title>
            </Helmet>
            <Row>
                <Col >
                    <CustomModalIcon
                        type="defaultIcon"
                        icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M11.302 21.6149C11.5234 21.744 11.6341 21.8086 11.7903 21.8421C11.9116 21.8681 12.0884 21.8681 12.2097 21.8421C12.3659 21.8086 12.4766 21.744 12.698 21.6149C14.646 20.4784 20 16.9084 20 12V7.21759C20 6.41808 20 6.01833 19.8692 5.6747C19.7537 5.37113 19.566 5.10027 19.3223 4.88552C19.0465 4.64243 18.6722 4.50207 17.9236 4.22134L12.5618 2.21067C12.3539 2.13271 12.25 2.09373 12.143 2.07827C12.0482 2.06457 11.9518 2.06457 11.857 2.07827C11.75 2.09373 11.6461 2.13271 11.4382 2.21067L6.0764 4.22134C5.3278 4.50207 4.9535 4.64243 4.67766 4.88552C4.43398 5.10027 4.24627 5.37113 4.13076 5.6747C4 6.01833 4 6.41808 4 7.21759V12C4 16.9084 9.35396 20.4784 11.302 21.6149Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        } 
                    />
                </Col>
                <Col className={styles.cancelIconCol}>
                        <svg className={styles.cancelIcon} onClick={() => backToSignin()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                </Col>
                
                
            </Row>
            <Row>
                <Col sm={12}>
                    <h3 className={styles.boxTopic}>Reset your password</h3>
                </Col>
                <Col>
                    <p className={styles.verificationcodeText}>We have sent you a 6 digit verification code to <span className={styles.setEmailText}>{props.setEmail}</span>. Please enter that verification code and new password below</p>
                </Col>
            </Row>
            {show === true &&
                <Row>
                    <Col sm={12} className={styles.alertColumn}>
                        {show === true ? (<CustomAlertBox alertBodyText={message} errorMessageId="forgotPassword_resetPassword_errorMsgId" alertType='dangerAlert'/>) : ''}
                    </Col>
                </Row>
            }
            <Formik
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{}}>
                {({
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit} onFocus={() => setShow(false)}>
                        <div className={styles.formDivRow}>
                            <CustomTextField
                                label="6-digit verification code"
                                classLabel="defaultLabel"
                                controlId="code"
                                type="text"
                                name="code"
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.code}
                                validationMessageId="forgotPassword_resetPassword_code_codeValidationMsgId"
                                isInvalid={submitCount > 0 && !!errors.code}
                            />

                            <CustomTextFieldPass
                                label="New Password"
                                classLabel="defaultLabel"
                                controlId="password"
                                name="password"
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.password}
                                validationMessageId="forgotPassword_resetPassword_password_newPasswordValidationMsgId"
                                isInvalid={submitCount > 0 && !!errors.password}
                            />
                        </div>
                        <div className={styles.formDivRow}>
                            <Row>
                                <Col>
                                    <CustomButton
                                        buttonType="button"
                                        id="forgotPassword_resetPassword_changePasswordCancelBtnId"
                                        label="Cancel"
                                        type="defaultBtn"
                                        disabled={isLoading === true ? true : false}
                                        handleClick={() => backClicked()}
                                    />
                                </Col>

                                <Col>
                                    <CustomButton
                                        buttonType="submit"
                                        id="forgotPassword_resetPassword_changePasswordBtnId"
                                        label="Change Password"
                                        type="primaryBtn"
                                        disabled={isLoading === true ? true : false}
                                        backicon=
                                        {isLoading === true ?
                                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                            : ''
                                        }

                                    />
                                </Col>
                            </Row>
                        </div>
                        <Col>
                            <p className={styles.termsPara}><a href="/privacy-policy" target="_blank" rel="noreferrer" className={styles.termsLink}>Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className={styles.termsLink}>Terms of Use.</a></p>
                        </Col>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default ResetPassword;
